<div class="col-md-6">
  <table class="simple-form">

    <tr>
      <th><label for="caxtonWalletName">Caxton Wallet Name</label></th>
      <td>
        <div class="form-group">
          <input type="text" id="caxtonWalletName" class="form-control" formControlName="caxtonWalletName">
        </div>
      </td>
    </tr>

    @if (patientPaymentInfo.trialCaxtonEnabled && patientPaymentInfo.subsidiaryLinkedToTrial) {
    <tr [class.visibility-hidden]="!authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th><label for="assignWallet">Available Wallets</label></th>
      <td>
        <div class="form-group">
          <app-autosuggest-dropdown-input #assignWalletSelect id="assignWalletSelect" [options]="assignWalletOptions"
            [parentForm]="paymentInfoForm" (selectValueChanged)="checkIfCardsExistOnWallet($event)"
            placeholder="Select Wallet"></app-autosuggest-dropdown-input>
        </div>
      </td>
    </tr>

    <tr *ngIf="paymentInfoForm.controls.caxtonWalletId.value">
      <th><label for="caxtonWalletId">Assigned Wallet</label></th>
      <td>
        <div class="form-group">
          <input type="text" id="caxtonWalletId" class="form-control" formControlName="caxtonWalletId">
        </div>
      </td>
    </tr>

    <tr *ngIf="!cardsExistOnWallet">
      <th></th>
      <td>
        <p class="no-cards-label"><i class="far fa-info-circle"></i>
          This wallet has no cards and should be archived in Caxton</p>
      </td>
    </tr>

    <tr
      *ngIf="!cardsExistOnWallet && authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th></th>
      <td>
        <button class="btn btn-outline btn-outline-slim test-connection-btn w-100" [disabled]="archivingWallet"
          (click)="onArchiveWalletClick()">
          <span *ngIf="archivingWallet">
            <span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!archivingWallet">Archive</span>
        </button>
      </td>
    </tr>

    <tr
      *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th></th>
      <td>
        <button class="btn btn-primary test-connection-btn w-100" [disabled]="!cardsExistOnWallet"
          (click)="showWalletAssignmentPopup()">
          <span>Assign and move wallet</span>
        </button>
      </td>
    </tr>

    <tr
      *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) && paymentInfoForm.get('caxtonWalletId').value && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th></th>
      <td>
        <button class="btn btn-secondary test-connection-btn w-100" [disabled]="linkingCardToTracker"
          (click)="linkCardToTracker()">
          <span>Link to Card Tracker</span>
        </button>
      </td>
    </tr>

    <tr *ngIf="(cardsActivated || caxtonOnlineAccessGranted) &&
                  authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) &&
                  paymentInfoForm.controls.caxtonWalletId.value">
      <th></th>
      <td>
        <div class="cards-activated-wrapper">
          <span *ngIf="cardsActivated" class="badge badge-success cards-activateds">Cards Activated</span>
          <span *ngIf="caxtonOnlineAccessGranted" class="badge badge-success online-access-granted">Online
            Access Granted</span>
        </div>
      </td>
    </tr>

    <tr
      *ngIf="cardsActivated &&
                  !caxtonOnlineAccessGranted &&
                  authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) &&
                  paymentInfoForm.controls.caxtonWalletId.value && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th></th>
      <td>
        <button class="btn btn-outline btn-outline-slim test-connection-btn w-100"
          (click)="showGrantCaxtonAccessPopup()">
          <span>Grant online access to Caxton</span>
        </button>
      </td>
    </tr>

    <tr *ngIf="!cardsActivated && !cardsStolen && !cardsBlocked && !cardsLost &&
                  authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) &&
                  paymentInfoForm.controls.caxtonWalletId.value">
      <th></th>
      <td>
        <button class="btn btn-outline btn-outline-slim test-connection-btn w-100" (click)="activateCards()">
          <span *ngIf="isCardActivationProcessing">
            <span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!isCardActivationProcessing">Activate Cards</span>
        </button>
      </td>
    </tr>

    <tr *ngIf="cardsActivated &&
                  itemVisible([RoleNames.ProductAdministrator, RoleNames.ProjectCoordinatorExpenses, RoleNames.CallCentre]) &&
                  paymentInfoForm.controls.caxtonWalletId.value">
      <th></th>
      <td>
        <button class="btn btn-outline btn-outline-slim test-connection-btn w-100" (click)="viewCardPin()">
          <span *ngIf="isCardPinProcessing">
            <span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!isCardPinProcessing">View Card Pin</span>
        </button>
      </td>
    </tr>

    <tr *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th *ngIf="cardsActivated || cardsBlocked"><label>Mark Card As</label></th>
      <td>
        <div class="card-actions">
          <app-button text="Lost" [disabled]="cardActionBusy" [isBusy]="cardActionBusy" size="xs" margin="none"
            variant="info" width="fill" *ngIf="!cardsLost && cardsActivated" (click)="onHandleMarkCardLostClick()" />
          <app-button text="Stolen" [disabled]="cardActionBusy" [isBusy]="cardActionBusy" size="xs" margin="none"
            variant="info" width="fill" *ngIf="!cardsStolen && cardsActivated"
            (click)="onHandleMarkCardStolenClick()" />
          <app-button text="Blocked" [disabled]="cardActionBusy" [isBusy]="cardActionBusy" size="xs" margin="none"
            variant="info" width="fill" *ngIf="!cardsBlocked && cardsActivated"
            (click)="onHandleMarkCardBlockedClick()" />
          <app-button text="Unblocked" [disabled]="cardActionBusy" [isBusy]="cardActionBusy" size="xs" margin="none"
            variant="info" width="fill" *ngIf="cardsBlocked" (click)="onHandleMarkCardUnblockedClick()" />
        </div>
      </td>
    </tr>

    <tr *ngIf="cardsActivated &&
                  authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) &&
                  paymentInfoForm.controls.caxtonWalletId.value">
      <th><label class="account-balance account-balance-label">Balance</label></th>
      <td>
        <div class="account-balance">
          <span *ngIf="isWalletBalanceProcessing">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!isWalletBalanceProcessing">{{walletBalance}}</span>
        </div>
      </td>
    </tr>

    <tr
      *ngIf="isDevelopmentEnv && selectedWallet && !selectedWallet.walletIsOnChildSubsidiary && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
      <th><label>QA Testing</label></th>
      <td>
        <button class="btn btn-outline btn-outline-slim test-connection-btn w-100" [disabled]="creatingTestWallet"
          (click)="createTestWalletOnChildSubsidiary()">
          <span *ngIf="creatingTestWallet">
            <span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!creatingTestWallet">Create Empty Wallet (Child Subsidiary)</span>
        </button>
      </td>
    </tr>
    }
  </table>
</div>

<app-confirm-wallet-assignment-modal #confirmWalletAssignmentModal [availableWalletsList]="availableWalletsList"
  (onConfirmWalletAssignmentResult)="onConfirmWalletAssignmentResult($event)" [paymentInfoForm]="paymentInfoForm"
  [patientId]="patientId"></app-confirm-wallet-assignment-modal>

<app-card-already-active-modal #cardAlreadyActiveModal [trialId]="trialId" [patientTrialId]="patientId"
  [paymentInfoForm]="paymentInfoForm" (walletAssigned)="onWalletAssigned()"></app-card-already-active-modal>

<app-grant-online-access-to-caxton #grantOnlineAccessToCaxtonComponent [patientId]="patientId"
  [paymentInfoForm]="paymentInfoForm" [patientBasicInfo]="patientBasicInfo"
  (caxtonOnlineAccessGranted)="onCaxtonOnlineAccessGranted($event)"></app-grant-online-access-to-caxton>

<app-confirm-action-modal #confirmActionModal (confirmed)="onCardActionConfirmed($event)" />

<app-modal #viewCardPinModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Card pin number</h2>
    </div>
    <div class="modal-body text-center ">
      <span *ngIf="isCardPinProcessing">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <img *ngIf="!isCardPinProcessing" class="card-pin-image" [src]="cardPinImageUrl" />
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-12">
          <a (click)="viewCardPinModal.hide()" class="btn btn-secondary" data-dismiss="modal">Close</a>
        </div>
      </div>
    </div>
  </div>
</app-modal>